import { render, staticRenderFns } from "./WorkflowFormBuilderDetailPage.vue?vue&type=template&id=6c7b3184&"
import script from "./WorkflowFormBuilderDetailPage.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderDetailPage.vue?vue&type=style&index=0&id=6c7b3184&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports